export const FETCH_LIST_ALL_DOCUMENT_TRASH_LIST_REQUEST = 'FETCH_LIST_ALL_DOCUMENT_TRASH_LIST_REQUEST'
export const FETCH_LIST_ALL_DOCUMENT_TRASH_LIST_SUCCESS = 'FETCH_LIST_ALL_DOCUMENT_TRASH_LIST_SUCCESS'
export const FETCH_LIST_ALL_DOCUMENT_TRASH_LIST_FALUIRE = 'FETCH_LIST_ALL_DOCUMENT_TRASH_LIST_FALUIRE'
export const FETCH_SEARCH_TDOC ='FETCH_SEARCH_TDOC'